import { styled } from "styled-components";

import logoPattern from "../../images/logoPattern.png";

export const FeaturedPostMeta = styled.div`
  color: ${({ theme }) => theme.colors.white};
  background: url(${logoPattern}), ${({ theme }) => theme.colors.vividBlue};
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: bottom right;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  div:first-child {
    text-align: right;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.hoverVividBlue};
  }
`;
